import React from "react";
import "./AboutContent.css";

const AboutContent = () => {
  return (
    <div>
      <div className="about-container">
        <div className="about-info">
          <div className="about-us">About Research showcase</div>
          <div className="about-content">
            <p>
              The Research Showcase is an event that highlights the innovative projects and research conducted by students at the Northeastern University at the end of every semester. This event serves as a platform for students to showcase their work, share their findings, and connect with industry professionals.
            </p>
            <p>
              The projects displayed at the research-showcase are usually the final project of the students, tackling a specific topic. 
              These projects are completed within a tight scheldue along with students completing their acedemic requirements, while adhering the best practicies adopted within the indusrty. 
              The students deliver not only a functional project but a project that is also well-documented and presented.
              Most of these projects are the result of the courses taken by the students, where they apply the knowledge learned to solve real-world problems.
            </p>
            <br />
            <p>
              Even though all of the projects are quite interesting on their own, but one category of these projects that can strike out are the capstone project, which is a culmination of the student's learning experience.
              A capstone is an end-of-program applied research project where students spend twenty hours per week, for fifteen weeks,
              investigating a research problem alongside an industry
              stakeholder. Even though most of the projects are related to
              machine learning, computer vision, networking, HCI, cloud
              computing, AI, NLP, speech recognition, or DevOps, they are not limited to these areas.
            </p>
            <br />
            <p>
              Depending on the problem statement, the project's scope includes a
              literature review of related work, identification of methodologies
              to solve the problem, an exploratory set of experiments with
              results, a final analysis, and future work. Students can work by themselves as well as in a team.
            </p>
          </div>
        </div>
        <div className="button-container">
          <a
            href="https://docs.google.com/forms/d/1i8THkmJn0ugdHYCynHIvSPHQ-2-lTf56gHPvhyRr8g8/viewform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="about-btn">BECOME A JUDGE</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
